import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AddButton from '../core/AddButton';
import { ProjectConsumer } from '../core/providers/ProjectProvider';

class CreateNodeDialogContainer extends Component {

  render() {

    const { onAddNewNode, parentIRI, onOpen, onClose, exclude, onAddExistingNode, searchClass, existing, excludeByPath, ontologyIRI,
      useSlashIRI, useUuidIRI, iriOptions, onlyComponentResources, useWorkflow,
      createDialog, searchClassFilter, disableMultiple, source, title, name, placeholder, button, graph } = this.props;
    const Dialog = createDialog;

    return (
      <ProjectConsumer>
        {({ id: projectIRI, defaultLang }) => (
          <Dialog
            button={button || <AddButton dataTest="create-node" title={name || "Add a node"} />}
            searchClass={searchClass}
            searchClassFilter={searchClassFilter}
            defaultLang={defaultLang}
            iriOptions={iriOptions}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useWorkflow={useWorkflow}
            onlyComponentResources={onlyComponentResources}
            useUuidIRI={useUuidIRI}
            parentIRI={parentIRI}
            onOpen={onOpen}
            graph={graph}
            source={source}
            onClose={onClose}
            existing={existing}
            excludeByPath={excludeByPath}
            disableMultiple={disableMultiple}
            exclude={exclude}
            placeholder={placeholder}
            projectIRI={projectIRI}
            title={title}
            onAddExistingNode={onAddExistingNode}
            onAddNewNode={onAddNewNode} />
        )}
      </ProjectConsumer>
    );
  }

}

CreateNodeDialogContainer.propTypes = {
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  searchClass: PropTypes.string.isRequired,
  searchClassFilter: PropTypes.array.isRequired,
  parentIRI: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  title: PropTypes.string,
  button: PropTypes.object,
  disableMultiple: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  exclude: PropTypes.array,
  ontologyIRI: PropTypes.string.isRequired,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,  
  existing: PropTypes.array,
  excludeByPath: PropTypes.func,
  onAddExistingNode: PropTypes.func.isRequired,
  onAddNewNode: PropTypes.func.isRequired,
  createDialog: PropTypes.object.isRequired,
  iriOptions: PropTypes.object
};

export default CreateNodeDialogContainer;